import { useMutation } from "@tanstack/react-query";

import salesApiService from "app/pages/sales-intelligence/services/salesApiService";

export const useNotifyAdminAboutSmallQuota = () => {
    return useMutation({
        mutationFn: (): Promise<void> => {
            return salesApiService.quota.notifyDataCreditsAdmin();
        },
    });
};
